import React from "react";
import "./MarkDownViewer.css";
import { withTranslation } from "react-i18next";

import "@toast-ui/editor/dist/toastui-editor.css";
import { Viewer } from "@toast-ui/react-editor";
import equal from "fast-deep-equal/es6";
import {Button} from "react-bootstrap";

const updateMarkdown = props => {
  let lang = props.lang || props.i18n.language.toLowerCase();
  let markdown =
    props.text[lang] ||
    props.text[props.defaultlanguage] ||
    (props.allowEmptyDescription ? "" : props.text["de"]);
  if (/-/.test(lang)) lang = lang.split("-")[0];
  markdown = markdown.replaceAll("&lt;br&gt;", "<br>");
  markdown = markdown.replaceAll("&#x2F;", "/");
  const lines = markdown.split("\n");
  return { lang, markdown: lines };
};

class MarkDownViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "",
      markdown: [],
      totalLines: 0,
      showedLines: 0
    };

    this.viewerRef = React.createRef();
    this.handleShowMore = this.handleShowMore.bind(this);
  }

  componentDidMount() {
    const { lang, markdown } = updateMarkdown(this.props);

    const showedLines = typeof this.props["showMaxLines"] !== "undefined"
    && this.props["showMaxLines"] <= markdown.length ? this.props["showMaxLines"] : markdown.length;

    this.setState({
      lang: lang,
      markdown: markdown,
      totalLines: markdown.length,
      showedLines: showedLines
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const setLang = this.props.lang || this.props.i18n.language.toLowerCase().split("-")[0];
    if (!equal(this.props.text, prevProps.text) || this.state.lang !== setLang) {
      const { markdown, lang } = updateMarkdown(this.props);
      this.setState({ markdown, lang });
    }
    if (!equal(this.state.markdown, prevState.markdown)) {
      const { markdown } = updateMarkdown(this.props);
      const markdownText = markdown.slice(0, this.state.showedLines).join("\n");
      this.viewerRef.current.getInstance().setMarkdown(markdownText);
    }
  }

  handleShowMore(event) {
    event.preventDefault();
    const markdown = this.state.markdown.slice(0, this.state.totalLines).join("\n");
    this.setState({ showedLines: this.state.totalLines });
    this.viewerRef.current.getInstance().setMarkdown(markdown);
  }

  render() {
    const markdown = this.state.markdown.slice(0, this.state.showedLines).join("\n");
    const moreButton = this.state.totalLines !== this.state.showedLines ? (
      <Button
         style={{ fontSize: "9pt" }}
         className="btn btn-green btn-sm"
         onClick={this.handleShowMore}>
        <i>{this.props.readMoreText}</i>
      </Button>
    ) : "";
    return (
      <div
        className={
          this.props.text && (this.state.lang || this.props.lang) ? "viewer-frame" : "display-none"
        }
      >
        {this.props.text && (this.state.lang || this.props.lang) ? (
          <Viewer initialValue={markdown} ref={this.viewerRef} />
        ) : (
          ""
        )}
        {moreButton}
      </div>
    );
  }
}

export default withTranslation()(MarkDownViewer);
